import { render, staticRenderFns } from "./AutomaticPaymentsDocumentsFilter.vue?vue&type=template&id=4b6ab00a&scoped=true"
import script from "./AutomaticPaymentsDocumentsFilter.vue?vue&type=script&lang=ts"
export * from "./AutomaticPaymentsDocumentsFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6ab00a",
  null
  
)

export default component.exports